import React from "react"
import { useIntl } from "../hooks"
import ContentProsSecurity from "./ContentProsSecurity"

export default function ContentPros() {
  const { t } = useIntl()
  const contentProsStatsFrames = [
    {
      id: 1,
      heading: t("ContentPros__StatsOne--Heading"),
      desc: t("ContentPros__StatsOne--Desc"),
    },
    {
      id: 2,
      heading: t("ContentPros__StatsTwo--Heading"),
      desc: t("ContentPros__StatsTwo--Desc"),
    },
    {
      id: 3,
      heading: t("ContentPros__StatsThree--Heading"),
      desc: t("ContentPros__StatsThree--Desc"),
    },
    {
      id: 4,
      heading: t("ContentPros__StatsFour--Heading"),
      desc: t("ContentPros__StatsFour--Desc"),
    },
  ]

  return (
    <div className="container pt-13 laptop:pt-19.5 laptop:mb-7 bg-white">
      <div className="flex flex-col-reverse laptop:flex-row">
        <div className="laptop:w-6/12 pt-8 grid grid-cols-1 grid-rows-4 tablet:grid-cols-2 laptop:grid-cols-2 tablet:grid-rows-2 laptop:grid-rows-2 gap-5 grid-flow-row">
          {contentProsStatsFrames.map((s) => (
            <div key={s.id} className="mx-auto px-4 pt-2.5 pb-5 bg-lightGrey rounded-32">
              <div className="mb-1">
                <h4 className="text-h1 leading-h1 tracking-66 font-sans text-socialiePink font-semibold">
                  {s.heading}
                </h4>
              </div>
              <p className="text-h6 text-body tracking-12 leading-h6 font-black">{s.desc}</p>
            </div>
          ))}
        </div>
        <div className="laptop:ml-1/12 laptop:w-5/12 flex items-center">
          <div className="px-2 laptop:px-0">
            <div className="mb-1.5">
              <h5 className="text-h6 text-darkGrey tracking-12 leading-h6 font-black">
                {t("ContentPros__BuiltBy--Subheading")}
              </h5>
            </div>
            <div className="mb-1.5">
              <h3 className="font-serif text-h4 text-body tracking-11 laptop:tracking-30 leading-h4">
                {t("ContentPros__BuiltBy--Heading")}
              </h3>
            </div>
            <p className="text-body text-p tracking-10 leading-h6">{t("ContentPros__BuiltBy--Desc")}</p>
            <span>&nbsp;</span>
            <p className="text-body text-p tracking-10 leading-h6">{t("ContentPros__BuiltBy--SecondaryDesc")}</p>
          </div>
        </div>
      </div>
      <div className="mt-17.5 laptop:mt-22">
        <ContentProsSecurity />
      </div>
    </div>
  )
}
